import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectedEtablissementService {
  private selectedEtabIdSubject = new BehaviorSubject<number | null>(null);
  selectedEtabId$: Observable<number | null> = this.selectedEtabIdSubject.asObservable();

  setSelectedEtablissement(etabId: number | null) {
    this.selectedEtabIdSubject.next(etabId);
    if (etabId) {
      sessionStorage.setItem('selectedEtabId', etabId.toString());
    } else {
      sessionStorage.removeItem('selectedEtabId');
    }
  }

  getSelectedEtablissement(): number | null {
    const etabId = sessionStorage.getItem('selectedEtabId');
    return etabId ? +etabId : null;
  }
}